import React, { useState } from 'react';
import { useLocation } from '../../context/LocationContext';
import LocationDrawer from './LocationDrawer';
import { toast } from 'react-toastify';

const LocationDisplay = () => {
  const { location, isLoading, error, updateLocation, getCurrentLocation } = useLocation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  // Handle location selection from LocationDrawer
  const handleLocationSelect = (locationData) => {
    updateLocation(locationData);
    // toast.success('Location updated successfully!');
  };

  // Function to get current location again
  const refreshLocation = () => {
    getCurrentLocation();
  };

  const formatLocationName = () => {
    if (!location) return 'Location not detected';
    
    if (location.cityName) {
      return location.cityName;
    }
    
    if (location.locationName) {
      return location.locationName;
    }
    
    return 'Unknown Location';
  };

  if (isLoading) {
    return (
      <div className="flex items-center space-x-1 text-gray-600">
        <div className="animate-spin h-3 w-3 md:h-4 md:w-4 border-2 border-primary border-t-transparent rounded-full"></div>
        <span className="text-xs md:text-sm truncate">Detecting location...</span>
      </div>
    );
  }

  if (error && !location) {
    return (
      <>
        <div
          className="flex items-center space-x-1 text-primary-dark cursor-pointer"
          onClick={() => setIsDrawerOpen(true)}
        >
          <svg className="h-3 w-3 md:h-4 md:w-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <span className="text-xs md:text-sm font-medium truncate">Select location</span>
          <svg className="h-2 w-2 md:h-3 md:w-3 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
        <LocationDrawer
          isOpen={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          onLocationSelect={handleLocationSelect}
          initialLocation={null}
        />
      </>
    );
  }

  return (
    <>
      <div className="flex items-center space-x-1 cursor-pointer max-w-[130px] md:max-w-[200px]" onClick={() => setIsDrawerOpen(true)}>
        <div className="flex items-center space-x-1 text-primary-dark">
          <svg className="h-3 w-3 md:h-4 md:w-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <span className="text-xs md:text-sm font-medium truncate">
            {formatLocationName()}
          </span>
          <svg className="h-2 w-2 md:h-3 md:w-3 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>

      <LocationDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        onLocationSelect={handleLocationSelect}
        initialLocation={location}
      />
    </>
  );
};

export default LocationDisplay; 